define([
	"dojo/_base/array",
	"dojo/_base/declare",
	"csi/heading/StringSelection",
	"csi/locale",
	"csi/store/_base",
	"csi/store/Names"
], function(array,declare,StringSelection,locale,csi_store,Names) {

	return declare(StringSelection, {
		consts : {

			TYPES: ["Style", "Sample", "MaterialSample", "FormulatedMaterialSample","Colorway", "Material", "ColorMaterial", "PackList", "PackListCarton", "PackListItem", "RecipeDataSheetRevision"]

		},

		getQuerySpec: function(/*Context*/ctx, /*Heading*/h, /*Spec*/spec) {
			// summary: disable filtering because of name change
			return null;
		},

		fromHtmlDynamic: function(/*Context*/ctx, /*Heading*/h, /*FilteringSelect*/editNode) {
			// summary: return attribute value from edit control
			return editNode.get("value");
		},

		getStore: function(/*Context*/ctx, /*Heading*/h, /*Any*/value, /*Boolean*/bAll) {
			// summary: create store for classes that we support
			return new Names({
				data: array.map(this.consts.TYPES, function(typeName) {
					return csi_store.nameObject(locale.type(typeName), typeName);
				})
			});
		},

		toValue: function(/*Context*/ctx, /*Heading*/h) {
			// summary: translate type store in Node Name
			return locale.type(ctx.getNode().$Name);
		}
	});
});